export default function Footer() {
  const socialLinks = [
    { icon: 'ri-facebook-circle-line', url: '#' },
    { icon: 'ri-twitter-x-line', url: '#' },
    { icon: 'ri-linkedin-box-line', url: '#' },
    { icon: 'ri-instagram-line', url: '#' }
  ];

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-8 py-20">
        <div className="grid grid-cols-12 gap-16 mb-16">
          <div className="col-span-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/03b3c577-2c0d-4b85-b1ea-97438588720f.png" 
              alt="DOO NOVA-GROSIS NIS" 
              className="h-16 w-auto mb-8"
            />
            <p className="text-gray-400 text-base leading-relaxed mb-10">
              Protecting your digital freedom with military-grade encryption and a strict no-logs policy. 
              Browse securely, privately, and without restrictions.
            </p>
            <div className="flex gap-5">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.url}
                  className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-black transition-all cursor-pointer"
                >
                  <i className={`${social.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="col-span-4">
            <div className="mb-12">
              <div className="text-xs uppercase text-gray-500 tracking-wider mb-3">Address</div>
              <div className="text-white text-base leading-relaxed">
                Nosioci Karadjordjeve Zvezde 21<br />
                Nis, 701129<br />
                Serbia
              </div>
            </div>
            <div className="mb-12">
              <div className="text-xs uppercase text-gray-500 tracking-wider mb-3">Phone</div>
              <div className="text-white text-base">+1 2312102800</div>
            </div>
            <div>
              <div className="text-xs uppercase text-gray-500 tracking-wider mb-3">Email</div>
              <div className="text-white text-base">support@doonova-grosisnis.com</div>
            </div>
          </div>

          <div className="col-span-4">
            <div 
              className="w-full h-[360px] rounded-2xl bg-cover bg-center"
              style={{
                backgroundImage: 'url(https://public.readdy.ai/ai/img_res/290aba5009fd678fcabe60c02a7b85fb.jpg)'
              }}
            ></div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex items-center justify-between">
          <div className="text-sm text-gray-500">
            © 2025 DOO NOVA-GROSIS NIS. All rights reserved.
          </div>
          <div className="flex gap-10">
            <a href="#" className="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Terms of Service
            </a>
            <a href="#" className="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Security
            </a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}